<template>
    <div class="dashboardCellAppInfo">
        <div class="appInfoWrapper">
            <div>
                <img class="image" width="32" height="32" :src="icon"/>
            </div>
            <span class="infoWrapper">
                <span class="infoName font-5 truncate" :class="{ archived }">
                    {{ name }}
                </span>
                <span class="infoMeta font-7">
                    {{ platform }} | App Key: {{ appKey }}
                </span>
            </span>
            <div class="editLink">
                <button
                   class="icon-button"
                   v-on:click="handleEditApp"
                   v-if="!archived">
                    <IconBase v-once
                              width="13"
                              height="13"
                              icon-name="editIcon"
                              :iconColor="iconColor"
                              :iconHoverColor="iconHoverColor"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'DashboardCellAppInfo',
    components: { IconBase },
    props: {
        appKey: String,
        name: String,
        icon: String,
        platform: String,
        archived: Boolean
    },
    data() {
        return {
            iconColor: consts.COLORS.DARK_300,
            iconHoverColor: consts.COLORS.PRIMARY_500
        };
    },
    methods: {
        handleEditApp() {
            this.$emit('editAppClicked', this.appKey);
        }
    }
};
</script>

<style scoped>
</style>
